import React, { useState, useEffect, useRef } from "react";
import { useStaticQuery, graphql } from "gatsby";
import classNames from "classnames";
import Modal from "react-overlays/Modal";
import IconClose from "../../icons/close-modal.svg";
import IconExpand from "../../icons/expand.svg";

const renderBackdrop = () => <div className="backdrop" />;

const isFullScreen = () => {
  return (
    document.fullscreenElement ||
    document.mozFullScreenElement ||
    document.webkitFullscreenElement ||
    document.msFullscreenElement
  );
};

const supportsFullScreen = () =>
  document.fullscreenEnabled ||
  document.webkitFullscreenEnabled ||
  document.mozFullScreenEnabled ||
  document.msFullscreenEnabled;

const requestFullscreen = () => {
  const el = document.documentElement;
  if (el.requestFullscreen) {
    el.requestFullscreen();
  } else if (el.msRequestFullscreen) {
    el.msRequestFullscreen();
  } else if (el.mozRequestFullScreen) {
    el.mozRequestFullScreen();
  } else if (el.webkitRequestFullscreen) {
    el.webkitRequestFullscreen();
  } else {
    console.warn("Fullscreen not supported");
  }
};

const exitFullscreen = () => {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  }
};

const LightboxModal = ({ show, onHide, className, noCloseSelector, children }) => {
  const { labelManagerLabels } = useStaticQuery(graphql`
    {
      labelManagerLabels: labelManagerLabels {
        close
      }
    }
  `);
  const [hasFs, setHasFs] = useState(false);
  useEffect(() => {
    setHasFs(supportsFullScreen());
  }, []);

  const toolbarRef = useRef();

  useEffect(() => {
    if (!show) {
      if (isFullScreen()) {
        exitFullscreen();
      }
    } else {
      const listener = (e) => {
        if (
          (noCloseSelector ? [...document.querySelectorAll(noCloseSelector)] : [])
            .concat(toolbarRef.current)
            .every((el) => !el.contains(e.target))
        ) {
          onHide();
        }
      };
      setTimeout(() => document.addEventListener("click", listener), 0);
      return () => document.removeEventListener("click", listener);
    }
  }, [show, noCloseSelector, onHide]);

  const toggleFs = () => {
    if (isFullScreen()) {
      exitFullscreen();
    } else {
      requestFullscreen();
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      className={classNames("lightbox-modal", className)}
      renderBackdrop={renderBackdrop}
      aria-hidden="false"
      aria-modal="true"
    >
      <div className="lightbox-modal__body">
        <div className="lightbox-modal__toolbar" ref={toolbarRef}>
          {hasFs && (
            <button
              aria-label="Toggle fullscreen"
              className="lightbox-modal__btn"
              onClick={toggleFs}
            >
              <IconExpand />
            </button>
          )}
          <button
            aria-label={labelManagerLabels.close}
            className="lightbox-modal__btn"
            onClick={onHide}
          >
            <IconClose />
          </button>
        </div>
        {children}
      </div>
    </Modal>
  );
};

export default LightboxModal;
